/**
 * Möbel, die im Elektromodus als eigenständige Elektromöbel bearbeitet werden.
 * Diese modellnahe Liste bleibt frei von Renderer-Imports, damit der zentrale
 * State sie ohne Importzyklus verwenden kann.
 */
const ELECTRICAL_FURNITURE_IDS = new Set([
  "lightGroup",
  "outdoorLightGroup",
  "electricalLight",
  "outdoorLight",
  "electricalButton",
  "electricalCamera",
  "electricalWindowContact",
  "electricalSensor",
  "electricalMotionSensor",
  "electricalSmokeSensor",
  "electricalDoorStation",
  "electricalJalousie",
  "electricalBlind",
  "electricalDistribution",
  "outdoorButton",
  "electricalOutlet",
  "outdoorOutletGroup",
  "fixedConsumer",
  "fixedConsumer400",
]);

export function isElectricalFurnitureId(definitionId: string): boolean {
  return ELECTRICAL_FURNITURE_IDS.has(definitionId);
}
